
define(
	'Convergence.featuredProd.featuredProd'
,   [
		'Convergence.featuredProd.featuredProd.View'
	,   'Convergence.featuredProd.featuredProd.Collection'
	]
,   function (
		featuredProdView
	,   featuredProdCollection
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			
			if(layout)
			{
				layout.addChildView('Featured.Product.Custom', function() { 
					var collection = new featuredProdCollection();
					var view = new featuredProdView({ 
						container: container,
						collection: collection
					 });

					return view;
				});
			}

		}
	};
});
